'use client';

import React, {FC, Suspense} from 'react';
import {useSearchParams} from 'next/navigation';

import Layout from './components/Layout';
import ResultsRoute from './components/ResultsRoute';
import {FhsProvider} from './store/FhsContext/context';

// `useSearchParams` opts the whole subtree into client-side rendering at the
// nearest Suspense boundary. Wrapping the consumer here keeps that bailout
// localized — the rest of the page can still stream.
const FinancialHealthScoreInner: FC = () => {
  const searchParams = useSearchParams();
  const isResultsMode =
    searchParams !== null && searchParams.get('results') !== null;

  if (isResultsMode) {
    return <ResultsRoute />;
  }

  return (
    <FhsProvider>
      <Layout />
    </FhsProvider>
  );
};

const FinancialHealthScore: FC = () => (
  <Suspense fallback={null}>
    <FinancialHealthScoreInner />
  </Suspense>
);

export default FinancialHealthScore;
